import { businessStore } from 'entities/index';
import { Loading } from 'pages/loading/ui/loading.page';
import React from 'react';
import { CreateManagerForm, Header } from 'widgets';
import { PageLayout } from 'shared/ui';

export const CreateManagerPage: React.FC = () => {
  const businessId = businessStore.businessId;
  return businessId ? (
    <PageLayout>
      <Header />
      <CreateManagerForm businessId={businessId} />
    </PageLayout>
  ) : (
    <Loading />
  );
};
